import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-expand-all",
  "use": "icon-expand-all-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-expand-all\">\r\n  <circle cx=\"12\" cy=\"12\" r=\"9\" stroke-width=\"2\" />\r\n  <line x1=\"12\" y1=\"7\" x2=\"12\" y2=\"17\" stroke-width=\"2\" stroke-linecap=\"round\" />\r\n  <line x1=\"7\" y1=\"12\" x2=\"17\" y2=\"12\" stroke-width=\"2\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol